export class SendPasswordResetEmailUseCaseImpl {
    constructor(authRepository) {
        this.authRepository = authRepository;
    }
    run(email) {
        return this.authRepository.sendPasswordResetEmail(email);
    }
}
